import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";
import { DirectorEducationalQualification } from "./directoreducationalqualification";
import { DirectorProfessionalExperience } from "./directorprofessionalexperience";
import {  DirectorFormsFiledAndIntimations } from "./directorformfiledandintimations";
import { DirectorOtherEnclosure } from "./directorotherenclosures";


export class Director extends EntityDto implements IEntityDto {
    Director_Id: string;
    DirectorName: string;
    Designation_Id: string;
    DIN: string;
    DIN_Ref_Id: string;
    DesignationName: String
    PAN: string;
    PAN_Ref_Id: string;
    Aadhar: string;
    Aadhar_Ref_Id: string;

    DOB: Date;

    AppointmentDate: Date;
    ReAppointmentDate: Date;
    Membership: boolean;
    EmailId: string;
    Phone: string;
    FormsFiled: string;
    FormsFiled_Ref_Id: string;

    IsActive: boolean;
    Document: any;
    Document_Name: string;
    FileName: string;
    Ref_Id: string | null;
    QualificationName: string;
    FormFiledName: string;
    ProfessionalName: string;
    OtherEnclosures: string;
    ExperienceYear: string;
    TotalCount: number;
    Document_Other: any;
    Document_Name_Other: string;
    FileName_Other: string;
    DirectorEducationalQualification: Array<DirectorEducationalQualification>;
    DirectorProfessionalExperience: Array<DirectorProfessionalExperience>;
    DirectorFormsFiledAndIntimations: Array<DirectorFormsFiledAndIntimations>;
    DirectorOtherEnclosure: Array<DirectorOtherEnclosure>;
    addressDocument: any;
    DINDocDownload: any;
    PANDocDownload: any;
    AdhaarDocDownload: any;
    DOADocDownload: any;
    DOBDocDownload: any;
    ReAppointmentDateDocDownload: any;
    MembershipDocDownload: any;
    DOB_Ref_Id: string;
    AppointmentDate_Ref_Id: string;
    ReAppointmentDate_Ref_Id: string;
    Membership_Ref_Id: string;
    AadhaarFileName:string="";
    DINFileName:string="";
    PANFileName:string="";
    DOBFileName:string="";
    DOAFileName:string="";
    ReAppointmentDateFileName:string="";
    MembershipFileName:string="";  
   
     constructor() {
        super();
        this.Director_Id = "00000000-0000-0000-0000-000000000000";
        this.DirectorName = "";
        this.Designation_Id = "";
        this.DIN = "";
        this.DIN_Ref_Id = "";
        this.Aadhar = "";
        this.Aadhar_Ref_Id = "";
        this.PAN = "";
        this.PAN_Ref_Id = "";
        this.DesignationName = "";
        this.Phone = "";
        this.IsActive = true;
        this.Document = null;
        this.Document_Name = "";
        this.FileName = "";
        this.Ref_Id = "";

        this.DOB = new Date();
        this.EmailId = "";
        this.AppointmentDate = new Date();
        this.ReAppointmentDate = new Date();
        this.Membership = false;

        this.FormsFiled = "";
        this.FormsFiled_Ref_Id = "";
        this.TotalCount = 0;
        this.QualificationName = "";
        this.FormFiledName = "";
        this.ProfessionalName = "";
        this.OtherEnclosures = "";
        this.ExperienceYear = "";
        this.Document_Other = null;
        this.Document_Name_Other = "";
        this.FileName_Other = "";
        this.DirectorEducationalQualification = [];
        this.DirectorProfessionalExperience = [];
        this.DirectorFormsFiledAndIntimations = [];
        this.DirectorOtherEnclosure=[];
        this.DOB_Ref_Id = "";
        this.AppointmentDate_Ref_Id = "";
        this.ReAppointmentDate_Ref_Id = "";
        this.Membership_Ref_Id = "";

        this.EntityMetaData = [
            { FieldName: 'DirectorName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Director Name is required' },
            { FieldName: 'Designation_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Designation is required' },
            // { FieldName: 'Phone', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Phone is required' },
            // { FieldName: 'EmailId', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Email is required' },
        ];
    }
}
